import React from 'react';
import {reduxForm} from 'redux-form';
import FormField from '../form/form-field';
import ImageField from '../form/image-field';
import BaseForm from '../form/base-form';
import LocalizedStrings from '../../localization/strings';
import PartnerCategorySelection from '../../components/partner-category/partner-category-select';
import Button from '../button';

import {validateRequiredFields} from '../../utils/form';
import Alert from '../alert';

const fields = ['id', 'name', 'imageId', 'link', 'order', 'partnerCategoryId'];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'name', 'imageId', 'partnerCategoryId'
    ], errors);
    return errors;
}

class PartnerForm extends BaseForm {
    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                name,
                imageId,
                link,
                order,
                partnerCategoryId
            }
        } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <FormField label={LocalizedStrings.name} name="name" field={name}>
                        <input ref="name" className="border-full larger" placeholder={LocalizedStrings.name}
                               type="text" {...name}/>
                    </FormField>

                    <FormField label={LocalizedStrings.link} name="link" field={link}>
                        <input ref="link" className="border-full larger" placeholder={LocalizedStrings.link}
                               type="text" {...link}/>
                    </FormField>

                    <FormField label={LocalizedStrings.logo} name="logo" field={imageId}>
                        <ImageField {...imageId}/>
                    </FormField>

                    <FormField label={LocalizedStrings.partnerCategory} name="season" field={partnerCategoryId}>
                        <PartnerCategorySelection field={partnerCategoryId}/>
                    </FormField>

                    <FormField label={LocalizedStrings.order} name="order" field={order}>
                        <input ref="link" className="border-full larger" placeholder={LocalizedStrings.order}
                               type="number" {...order}/>
                    </FormField>

                    <div className="actions-row">
                        <Button loading={submitting} submit={true} disabled={submitting} type="primary">
                            {LocalizedStrings.submit}
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'partner-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: state.admin.partners.partner}))(PartnerForm);



// WEBPACK FOOTER //
// ./src/js/components/partner/partner-form.js